import { Trans, useTranslation } from 'i18n';
import { Link } from 'ui';

export const TermsAndPolicyAgreement = () => {
  const { t: tCommon } = useTranslation('common');

  return (
    <span>
      <Trans
        namespace="features"
        i18nKey="auth.termsAndPolicyAgreement.fullSentence"
        values={{ brandName: tCommon('brand.name') }}
        components={{
          privacyLink: <Link href="https://www.safi.co/privacy-policy" target="_blank" />,
          termsLink: <Link href="https://www.safi.co/terms" target="_blank" />,
        }}
      />
    </span>
  );
};
